export interface IClsOverrideData {
    lostWageReimbursement: number;
    donorLifeInsurance: number;
    donorDisabilityInsurance: number;
    coverageforUncoveredComplications: number;
    legalRepresentation: number;
    remoteDonation: number;
    patientMicrosites: number;
    otherPrograms: number;
    otherProgramsDetails: string;
    prioritizationForDeceasedDonorTransplant: number;
    travelLodgingReimbursement: number;
    lostWageReimbursementForComplication: number;
    travelLodgingReimbursementForComplication: number;
    prioritizationForLivingDonorTransplant: number;
    nonSteroidalProtocol: number;
    nldacLostWage: number;
    nldacTravelLodging: number;
}